module.exports = __webpack_public_path__ + "static/media/parrot.6e226a39.png";